export default {
  gamesData: [],
  gamesToPlay: [],
  animeData: [],
  animesToPlay: [],
  seriesData: [],
  seriesToPlay: [],
  lifes: ["♥", "♥", "♥", "♥", "♥"],
  puntuacionAnime: 0,
  puntuacionGames: 0,
  puntuacionSeries: 0,
  isLoading: false,
};
